import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, Divider } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import ViewLargeCustomers from './ViewLargeCustomers'
import { getSalesPeopleDropDown, } from './LargeProjectUtils'
import Select from 'react-select';
import ViewLargeProjectCosts from './ViewLargeProjectCosts';
import LargeProjectsNav from './LargeProjectsNav'
import { SingleDatePicker } from 'react-dates';
import { getSalesPeople } from './ApiUtils'


import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class ClosePayNowProjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            salesPeopleChoices: [],
            salesPersonId: '',
            dateNum: '',
            loading: false,
        }
    }

    componentDidMount() {
        console.log("clpnw1 ++++++++++ ClosePayNowProjects componentDidMount");

        getSalesPeople(this.loadSalesPeople);
    }

    loadSalesPeople = (salesPeople) => {
        console.log("clpnw12 ++++++++:loadSalesPeopleDropdown");
        //console.log("gtc15:"+JSON.stringify(salesPeople,null,3));
        if (salesPeople && salesPeople.length > 0) {
            console.log("clpnw13 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        } else {
            alert("clpnw14 unable to load customers")
        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("clpnw15 e.target.name:" + e.target.name);
        console.log("clpnw15 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    handleDropDownChanges = (value) => {
        console.log("clpnw15 handleDropDownChanges");
        console.log('clpnw15 You\'ve sss:', value);
        console.log("clpnw15 category alone:" + value.category);
        console.log('clpnw15 You\'ve selected:', value.value + " " + value.category);
        console.log("clpnw15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("clpnw15 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    resetFeilds = () => {
        this.setState({
            salesPersonId: '',
            dateNum: '',
            loading: false 
        })
    }



    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    closePayNowProjects = () => {
        console.log("++++++++:closePayNowProjects");
        console.log("clpnw17 salesPersonId:" + this.state.salesPersonId)
        console.log("clpnw18 dateNum:" + this.state.dateNum)
        console.log("clpnw19 salesPersonId:" + this.props.user.email)

        if (this.state.salesPersonId == '') {
            alert("No salesPersonId ")
        } else if (this.state.dateNum == '') {
            alert("No project Selected")
        } else if (this.state.cost == '') {
            alert("No cost Entered")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });


            axios.post(pythonApiIp + 'closePayNowProjects', {
                apiKey: "asdf#adf",
                salesPersonId: this.state.salesPersonId,
                enteredBy: this.props.user.email,
                datePaid: this.state.dateNum
            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. closePayNowProjects");

                        this.resetFeilds();

                        alert(response.data.message);
                    } else {
                        console.log("FAILED");
                        alert(response.data.message);
                        this.setState({ loading: false });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const salesPeopleDropDown = this.state.salesPeopleChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.salesPersonId}
                options={this.state.salesPeopleChoices}
                onChange={this.handleDropDownChanges}
                searchable={true}
                clearable={false}
            />
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                <Divider>{'CLOSE PAY NOW PROJECTS'}</Divider>


                <Form size='large' onSubmit={this.closePayNowProjects}>
                    <Segment stacked>


                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>

                        <label>Select Sales Person</label>
                        {salesPeopleDropDown}


                        <Button>SEND</Button>
                    </Segment>

                </Form>

            </div>
        );
    }
}

export default ClosePayNowProjects;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ClosePayNowProjects.js